import InfoNotice from "./InfoNotice";
export default function InfoNoticeEssay() {
    return (
        <InfoNotice>
            <b>This essay was written during my time as a high school student for my dual-credit college courses.</b> As can be expected from my younger self, there may be some outdated vernacular, shortcomings, or other mishaps throughout. While some small factual, personal, and general quality assurance corrections have been made, I've conducted a faithful attempt to retain most of the essay's content.
        </InfoNotice>
    );
}